import { styled } from "@mui/material";
import { MessageBody } from "./MessageBody";

export const AgentMessage = styled(MessageBody)(({ theme }) => ({
    backgroundColor: "transparent",
    color: theme.palette.gray[700],
    borderRadius: 0,
    padding: 0,
    "& > :first-of-type, & > :only-child > :first-of-type": {
        marginTop: 0,
    },
    "& > :last-child, & > :only-child > :last-child": {
        marginBottom: 0,
    },
}));
